import { message } from 'antd';
import { toast } from 'react-toastify';

// 消息提示服务
class NotificationService {
  constructor() {
    this.useAntd = true;
    this.useToastify = false;
    this.init();
  }

  init() {
    // 不使用antd; antd有问题
    this.useAntd = false;
    this.useToastify = true;
  }

  // 成功提示
  success(content, options = {}) {
    if (this.useAntd) {
      message.success(content, options);
    } else if (this.useToastify) {
      toast.success(content, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  }

  // 错误提示
  error(content, options = {}) {
    if (this.useAntd) {
      message.error(content, options);
    } else if (this.useToastify) {
      toast.error(content, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  }

  // 警告提示
  warning(content, options = {}) {
    if (this.useAntd) {
      message.warning(content, options);
    } else if (this.useToastify) {
      toast.warning(content, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  }

  // 信息提示
  info(content, options = {}) {
    if (this.useAntd) {
      message.info(content, options);
    } else if (this.useToastify) {
      toast.info(content, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  }

  // 加载提示
  loading(content, options = {}) {
    if (this.useAntd) {
      return message.loading(content, 0, options);
    } else if (this.useToastify) {
      return toast.loading(content, {
        position: "top-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        ...options
      });
    }
  }

  // 销毁所有提示
  destroy() {
    if (this.useAntd) {
      message.destroy();
    } else if (this.useToastify) {
      toast.dismiss();
    }
  }

  // 手动切换提示方式
  switchToToastify() {
    this.useAntd = false;
    this.useToastify = true;
  }

  switchToAntd() {
    this.useAntd = true;
    this.useToastify = false;
  }
}

// 创建单例实例
const notification = new NotificationService();

export default notification;
